import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from '../store/app.state';
import { Actions } from '@ngrx/effects';

@Injectable()
export class AuthenticationService {
    private tokenSubject: BehaviorSubject<any>;
    public token: Observable<any>;

    constructor(
        private store$: Store<IAppState>,
        private actions$: Actions
    ) {
        this.tokenSubject = new BehaviorSubject<any>(localStorage.getItem('token'));
        this.token = this.tokenSubject.asObservable();
    }

    public get currentTokenValue(): any {
        return this.tokenSubject.value;
    }

    finishLogin(token: string) {
        if (token !== undefined) {
            localStorage.setItem('token', token);
            this.tokenSubject.next(token);
            return true;
        } else {
            return false;
        }
    }

    finishPublicLogin(token: string) {
        localStorage.setItem('token', token);
        this.tokenSubject.next(token);
        return true;
    }

    logout() {
        localStorage.removeItem('token');
        this.tokenSubject.next(null);
        window.location.href = '/';
    }
}